var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{ref:"toast",attrs:{"id":"toast"}},[_c('div',{staticClass:"toast",style:(`width: ${_vm.width}`)},[(_vm.icon)?_c('img',{attrs:{"src":require(`@/assets/img/message/${_vm.icon}.png`)}}):_vm._e(),_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }